import { useState } from "react";
function useOpenState({ isOpen, defaultOpen }) {
    const [open, setOpen] = useState(defaultOpen || false);
    const definedOpen = void 0 !== isOpen ? isOpen : open;
    return [
        definedOpen,
        setOpen
    ];
}
const useOpenState_useOpenState = useOpenState;
export default useOpenState_useOpenState;
